import { render, staticRenderFns } from "./FolderProperties.vue?vue&type=template&id=1e95581e&scoped=true"
import script from "./FolderProperties.vue?vue&type=script&lang=ts"
export * from "./FolderProperties.vue?vue&type=script&lang=ts"
import style0 from "./FolderProperties.vue?vue&type=style&index=0&id=1e95581e&lang=scss&scoped=true"
import style1 from "./FolderProperties.vue?vue&type=style&index=1&id=1e95581e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e95581e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e95581e')) {
      api.createRecord('1e95581e', component.options)
    } else {
      api.reload('1e95581e', component.options)
    }
    module.hot.accept("./FolderProperties.vue?vue&type=template&id=1e95581e&scoped=true", function () {
      api.rerender('1e95581e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FolderProperties.vue"
export default component.exports